<template>
    <main role="main">
        <article class="layout-contents-container" data-details>
            <div class="layout-page-title">
                <button type="button" class="buttons-icon" data-type="line" data-icon="back" v-on:click="goBack()"></button>
                <h1 v-if="wtlId && wtlId !== 'new'" class="page-title">{{ $t('SETTING.WHITELIST.HEADER.UPDT_TITLE')}}</h1>
                <h1 v-else class="page-title">{{ $t('SETTING.WHITELIST.HEADER.CREA_TITLE')}}</h1>
            </div>
            <div v-if="!pending" class="layout-contents" data-details>
                <fieldset class="forms">
                    <!--Summary-->
                    <table class="tbl-forms">
                        <caption></caption>
                        <tbody>
                        <tr>
                            <td colspan="2" v-if="wtlId && wtlId === 'new'">
                                <!--특정 리소스를 검사에서 제외할 수 있는 차단 목록 템플릿을 생성해 보세요.-->
                                {{ $t('SETTING.WHITELIST.HEADER.CREA_DESC')}}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <label>{{ $t('SETTING.WHITELIST.LABEL.NAME')}}<span class="icon-required"></span>
                                </label>
                            </th>
                            <td>
                                <label>
                                    <input type="text" class="text-field" style="width: 400px;"
                                           v-bind:data-invalid="invalidName"
                                           v-bind:placeholder="$t('SETTING.WHITELIST.PLACEHOLDER.NAME')"
                                           v-model="whitelistInfo.titl"
                                           @change="checkInvalidName"
                                    >
                                </label>
                                <p class="invalid-message" v-if="invalidName">{{ invalidNameMsg }}</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <label>{{ $t('SETTING.WHITELIST.LABEL.DESC')}}</label>
                            </th>
                            <td>
                                <label>
                                    <input type="text" class="text-field" style="width: 800px;"
                                           @focusout="checkInvalidDesc"
                                           v-bind:data-invalid="invalidDesc?true:null"
                                           v-bind:placeholder="$t('SETTING.WHITELIST.PLACEHOLDER.DESC')"
                                           v-model="whitelistInfo.desc">
                                </label>
                                <p class="invalid-message" v-if="invalidDesc">{{ $t('SETTING.WHITELIST.ERROR.MAX', {'cnt' : 400}) }}</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <label>{{ $t('SETTING.WHITELIST.LABEL.APPLY_RESOURCE')}}<span class="icon-required"></span></label>
                            </th>
                            <td>
                                <button type="button" class="buttons"
                                        data-size="s"
                                        data-icon="add"
                                        data-trigger="add-resource"
                                        @click="openAddingResourceForm">
                                    {{ $t('SETTING.WHITELIST.BUTTON.ADD_RESOURCE')}}
                                </button>
                                <span>{{ $t('SETTING.WHITELIST.MESSAGE.CLICK_ADD_RESOURCE_2')}}</span>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                    <!--Resource List-->
                    <div class="box-container">
                        <fieldset class="tbl-actions">
                            <button type="button" class="buttons" data-type="line" data-size="s" data-icon="delete" data-trigger="delete-resource"
                                    :disabled="removeRsrcList.length < 1"
                                    v-on:click="removeResource"
                                    >{{ $t('SETTING.WHITELIST.BUTTON.DELETE_RESOURCE')}}</button>
                        </fieldset>

                        <ag-whitelist
                            v-if="!pending" gridId="gridData"
                            :rowData="getWlRsrcList()"
                            :overlayNoRowsTemplate="listNoRowsTemplate"
                            :customStyle="customStyle"
                            :selectedCloud="selectedCloud"
                            @onChecked="onResourceListChecked($event)"
                            :key="getLocale">

                        </ag-whitelist>
                    </div>

                    <div class="forms-submit">
                    <button type="button"
                        class="buttons"
                        data-size="l"
                        @click="cancelModify">{{ $t('COMMON.BUTTON.CAMEL.CANCEL')}}</button>
                    <button type="button"
                        class="buttons"
                        data-type="key"
                        data-size="l"
                        :disabled="isDisableAddRsrc"
                        @click="finishModify">{{ $t('COMMON.BUTTON.UPPER.OK')}}</button>
                </div>
                </fieldset>
                <AddingResourceComponent
                    :preSortObject="preSortObject"
                    :isOpen="isOpenARCmpnt"
                    :inUseVendors="inUseVendors"
                    :accounts="filterItems.accounts"
                    :products="filterItems.products"
                    :regions="filterItems.regions"
                    :paging="paging"
                    :isSideLoading="isSideLoading"
                    :resourceList="resourceListByKey"
                    :callSetSortKey="setSortKey"
                    :callSetSearchKey="setSearchKey"
                    :callAddResource="addResource"
                    :callApplyFilterKeys="setFilterKeys"
                    :callSetVendorKey="setVendorKey"
                    :callSetCurrentPage="setCurrentPage"
                    :callSetRowsPerPage="setRowsPerPage"
                    :callCloseARC="closeARCmpnt"
                />
            </div>
            <div-loading v-if="pending" :full="true"></div-loading>
        </article>
        <Modal
            :title="modal.popupTitle"
            :message="modal.popupMessage"
            :isShowPopup="modal.isShowPopup"
            :callOnHide="handleHideModal"
            :isOKOnly="modal.isOKOnly"
        />
    <div>
    </div>
    </main>

</template>

<script>

import settingsHeader from './settingsHeader.vue';
import AgWhitelist from "../ag-grid/ag-whitelist.vue";
import AddingResourceComponent from "./settingComponents/AddingResourceComponent.vue";
import {mapGetters} from "vuex";
import Modal from "../common/Modals/Modal.vue";
import {EventBus} from "../common/event-bus";

export default {
    name: 'SettingsWhiteListModify',
    components: {
        AddingResourceComponent,
        settingsHeader,
        AgWhitelist,
        Modal
    },
    data() {
        return {
            preSortObject: {},
            sortObject: {},
            isSaving: false,
            isOpenARCmpnt: false,
            filterKeys: {},
            modal: {
                isShowPopup: false
            },
            wtlId : this.$route.params.wtlId,
            whitelistInfo : {
                titl:null,
                desc:null,
                wtlId:null,
                rsrcList:[],
            },
            removeRsrcList:[],

            pending: false,
            isSideLoading : false,

            invalidResourceCount : false,
            invalidName : false,
            invalidNameMsg:null,
            invalidDesc:false,
            listNoRowsTemplate: `<p class='overlay-nodata'>${this.$t('SETTING.WHITELIST.ERROR.RESOURCE_MONE')}<br>${this.$t('SETTING.WHITELIST.MESSAGE.CLICK_ADD_RESOURCE_1')}<br>${this.$t('SETTING.WHITELIST.MESSAGE.CLICK_ADD_RESOURCE')}</p>`,//검색 결과가 없습니다.
            selectedCloud: '',
            resourceList:[],
            resourceListByKey: [],
            paging: {
                rowPerPage: this.constants.NUM.RESOURCE_ROW_PER_PAGE,
                currentPage: 1,
                totalPage: 0,
                totalItem: 0,
                isReloadPagination: false
            },
            selectedResources: [],
            searchTxt: '',
            filterItems: {},
            cloudKey: null,
            customStyle : "position: relative; width : 100%; height : 200px",
            inUseVendors: [],
        }
    },
    created() {
        EventBus.$on("changeLocale", e => {
            this.listNoRowsTemplate = `<p class='overlay-nodata'>${this.$t('SETTING.WHITELIST.ERROR.RESOURCE_MONE')}<br>${this.$t('SETTING.WHITELIST.MESSAGE.CLICK_ADD_RESOURCE_1')}<br>${this.$t('SETTING.WHITELIST.MESSAGE.CLICK_ADD_RESOURCE')}</p>`
        });
    },
    mounted: function() {
        this.selectWhiteList();
        this.selectFilterItems();
    },
    updated() {
        let dom = document.querySelector('#gridData .ag-center-cols-container');
        if (dom && dom.clientHeight > 1){
            let height = 50 + dom.clientHeight + 'px';
            this.customStyle = "position: relative; width : 100%; height : " + height;
        }
    },
    computed:{
        ...mapGetters({
            curCmpnId: 'user/curCmpnId'
        }),
        isDisableAddRsrc() {
            if (this.invalidName || this.invalidDesc || this.whitelistInfo.rsrcList.length < 1 || this.isSaving) {
                return true;
            }
            return false;
        },
        getCurWtlId:function (){
            return this.$route.params.wtlId;
        },
        getLocale: function() {
            return this.$i18n.locale;
        }
    },
    watch:  {
        curCmpnId: function() {
            this.$router.replace(`/settings/whitelist`);
        },
        cloudKey(newVal, oldVal) {
            this.getFilterItems(this.filterData, newVal);
        },
        "whitelistInfo.rsrcList"(newval) {
            if (newval.length > 0) {
                this.checkInvalidName();
                this.checkInvalidDesc();    
            }
        }
    },
    destroyed: function() {
        $('body').removeAttr('data-wing-expand');
        // remove tempRsrc
    },
    methods: {
        setSortKey(sortTarget) {
            console.log("setSortKey: ", sortTarget);
            this.sortObject = sortTarget;
            this.preSortObject = sortTarget;
            this.slctRsrc();
        },
        closeARCmpnt() {
            this.isOpenARCmpnt = false;
            this.filterKeys.cloudKey = undefined;            
        },
        setFilterKeys(keys) {
            this.filterKeys = keys;
        },
        handleHideModal() {
            this.modal.isShowPopup = false;
        },
        setVendorKey(key) {
            this.cloudKey = key;
        },
        setCurrentPage(e) {
            const curPage = e > 0 ? e : 1;
            this.paging.currentPage = curPage;
            this.debounceSelectResources();
        },
        setSearchKey(key) {
            this.searchTxt = key;
            this.getResourceListByKey();
        },
        setRowsPerPage(rpp) {
            this.paging.rowPerPage = rpp.rowsPerPage;
            this.paging.currentPage = rpp.currentPage;
            this.debounceSelectResources();
        },
        getFilterItems(filterData, cloudKey) {
            let products = [];
            let accounts = [];
            let regions = [];
            if (cloudKey == null) {
                _.forEach(filterData, (dataByVendor) => {
                    let productByVendor = _.get(dataByVendor, 'products', []);
                    products = [].concat.apply(products, productByVendor);

                    let accountByVendor = _.get(dataByVendor, 'accounts', []);
                    accounts = [].concat.apply(accounts, accountByVendor);

                    let regionByVendor = _.get(dataByVendor, 'regions', []);
                    regions = [].concat.apply(regions, regionByVendor);
                });
            } else {
                _.forEach(filterData, (dataByVendor) => {
                    if (dataByVendor.vendor.toLowerCase() === cloudKey.toLowerCase()) {
                        let productByVendor = _.get(dataByVendor, 'products', []);
                        products = [].concat.apply(products, productByVendor);

                        let accountByVendor = _.get(dataByVendor, 'accounts', []);
                        accounts = [].concat.apply(accounts, accountByVendor);

                        let regionByVendor = _.get(dataByVendor, 'regions', []);
                        regions = [].concat.apply(regions, regionByVendor);
                    }
                });
            }
            this.filterItems = {accounts, regions, products};
        },
        getWlRsrcList: function() {
            return _.get(this.whitelistInfo, 'rsrcList', [] );
        },
        // 전체 resource 목록에서 filter 적용하기
        getResourceListByKey(){
            this.debounceSelectResources();
        },
        goBack() {
            this.$router.go(-1);
        },
        // mapping되어 있는 resource list 조회
        selectWhiteList(){
            if(this.getCurWtlId && this.getCurWtlId !== 'new'){
                this.selectWhitelistMaster();
            }else{
                this.whitelistInfo.titl="";
                this.whitelistInfo.desc="";
                this.whitelistInfo.rsrcList = []
            }
        },
        // 전체 resource 목록 팝업 불러오기
        async openAddingResourceForm() {
            await this.getVendorData();
            this.slctRsrc();
            $('body').toggleAttr('data-wing-expand', '');
            this.isOpenARCmpnt = true;
            this.debounceSelectResources = _.debounce(this.slctRsrc, 500);
        },

        async getVendorData() {
            const url = "/api/governance/dashboard/vendor";
            const header = {
                'cmpnId': this.curCmpnId
            };
            try {
                const response = await this.http.post(url, header);
                const vendors = _.get(response, "data");
                if (vendors) {
                    this.inUseVendors = vendors;
                    this.cloudKey = vendors[0].CLOUD_VNDR_ID;
                } else {
                    console.log("getVendorData: No Data")
                    return [];
                }                
            } catch (err) {
                console.error("getVendorData: ", err);
            }
        },

        selectFilterItems() {
            const header = {
                'cmpnId': this.curCmpnId,
            };
            const url = `/api/governance/setting/whitelist/modify/filterdata`;
            this.http.post(url, JSON.stringify(header))
                .then(result => {
                    if (result.status === 200){
                        this.filterData = result.data;
                        this.getFilterItems(this.filterData, this.cloudKey);
                    }
                });
        },
        async slctRsrc() {
            this.isSideLoading = true;
            const filter = this.filterKeys;
            const {rowPerPage, currentPage} = this.paging;
            const vndr = _.get(filter, 'cloudKey', this.cloudKey);
            const includeAccnt = _.get(filter, 'accountKeys', []);
            const includePrdct = _.get(filter, 'productKeys', []);
            const includeRgn = _.get(filter, 'regionKeys', []);    
            const url = "/api/governance/setting/whitelist/modify/all";
            const header = {
                'cmpnId': this.curCmpnId,
                'rowPerPage':   rowPerPage,
                'currentPage':  currentPage,
                'isLimitPage':  true,
                'excludeRsrc': this.selectedResources,
                sortColumn: this.sortObject.sortColumn,
                sortOrder: this.sortObject.sortOrder,
                vndr,
                includeAccnt,
                includePrdct,
                includeRgn,
                srchText: this.searchTxt
            };
            try {
                const result = await this.http.post(url, JSON.stringify(header));
                if (result.status === 200) {
                    this.resourceList = result.data.result;
                    this.paging = _.get(result, 'data.pagination', {});
                    // 전체 resource 중에서 이미 mapping되어 있는 resource는 제외하기
                    const self = this;
                    this.resourceList = _.filter(this.resourceList, function (rsrc) {
                        return (_.findIndex(self.getWlRsrcList, function(o){ return o.instId === rsrc.instId}) < 0);
                    });
                    // this.getResourceListByKey();

                    this.resourceListByKey = _.cloneDeep(this.resourceList);
                }
            } catch (e) {
                console.error("slctRsrc: ", e);
            } finally {
                this.isSideLoading = false;
                this.paging.isReloadPagination = false;
            }
            
        },
        // 전체 resource 목록 팝업에서 resource 추가하기
        addResource(tempResourceList){
            if(this.getWlRsrcList.length + tempResourceList.length > 1000){
                this.modal = {
                    isShowPopup: true,
                    popupTitle: this.$t('SETTING.WHITELIST.POPUP.TITLE.ADD_RESOURCE'),
                    popupMessage: this.$t('SETTING.WHITELIST.POPUP.DESC.ADD_RESOURCE'),
                    isOKOnly: true
                }
            } else {
                let rsrcList = this.whitelistInfo.rsrcList;
                rsrcList = rsrcList.concat(tempResourceList);
                this.selectedResources = this.getSelectedResourceId(rsrcList);
                this.whitelistInfo.rsrcList = rsrcList;
                //this.resourceList = _.remove(this.resourceList, tempResourceList);
            }
            this.paging.currentPage = 1;
            this.getResourceListByKey();
        },
        getSelectedResourceId(tempResourceList) {
            let selectedResource = [];
            _.forEach(tempResourceList, (item) => {
                selectedResource.push(item.instId);
            });
            return selectedResource;
        },
        // whitelist 정보 담기
        selectWhitelistMaster(){
            let url = `/api/governance/setting/whitelist/info`;
            let header = {
                "cmpnId": this.curCmpnId,
                "wtlId": this.getCurWtlId
            };
            this.pending = true
            this.http.post(url, JSON.stringify(header))
                .then(response => {
                    if(response.data.status === 'ok'){
                        this.whitelistInfo = response.data.result;
                        this.pending = false
                    }
                });
        },
        // 적용된 resource에서 제거하긱
        removeResource() {
            if (this.whitelistInfo.rsrcList.length == this.removeRsrcList.length) {
                console.log("At least 1 resource");
                this.modal = {
                    popupTitle: this.$t('SETTING.WHITELIST.POPUP.TITLE.DELETE_RESOURCE_ONE'),
                    popupMessage: this.$t('SETTING.WHITELIST.POPUP.DESC.DELETE_RESOURCE_ONE'),
                    isShowPopup: true,
                    isOKOnly: true,
                }
            } else {
                this.whitelistInfo.rsrcList = _.differenceWith(this.whitelistInfo.rsrcList, this.removeRsrcList)
                this.selectedResources = this.getSelectedResourceId(this.whitelistInfo.rsrcList);
                this.removeRsrcList = [];
            }
        },
        // 수정화면에서 빠져나가기
        cancelModify() {
            this.$router.replace(`/settings/whitelist`);
        },
        // 수정화면에서 저장하기
        finishModify() {
            this.isSaving = true;
            if(this.whitelistInfo.rsrcList.length < 1){
                this.invalidResourceCount = true;
                return;
            }
            this.invalidResourceCount = false;
            this.whitelistInfo.cmpnId = this.curCmpnId;
            this.whitelistInfo.wtlId = this.getCurWtlId;

            let url = `/api/governance/setting/whitelist/change`;
            this.http.post(url, JSON.stringify(this.whitelistInfo))
                .then(response => {
                    if(response.data.status === 'ok'){
                        this.$router.replace(`/settings/whitelist`);
                    }
                });
        },
        checkInvalidName() {
            if(!this.whitelistInfo.titl || this.whitelistInfo.titl.length === 0){
                this.invalidName = true;
                this.invalidNameMsg = this.$t('SETTING.WHITELIST.ERROR.NAME_NONE');
            }else if(this.whitelistInfo.titl.length > 200){
                this.invalidName = true;
                this.invalidNameMsg = this.$t('SETTING.WHITELIST.ERROR.MAX', {'cnt' : 200});
            }else{
                this.invalidName = false;
            }
        },
        checkInvalidDesc(){
            this.invalidDesc = !!(this.whitelistInfo.desc && this.whitelistInfo.desc.length > 400);
        },
        // 리소스 추가/삭제 리스트에서 checkbox 클릭했을때 이벤트
        onResourceListChecked(evt) {
            this.removeRsrcList = evt.value
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/settings/settingsWhitelistModify.vue